import classNames from "classnames";
import AscCircularProgressBar from "../../AscCircularProgressBar/AscCircularProgressBar";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscLearningActivityCard.module.scss";
import { ArrowUpIcon } from "../../AscIcons/index";

export interface AscLearningActivityCardProps {
  completedPercentage: number;
  learningHours: number;
  className?: string;
  loading?: boolean;
  differenceToPreviousWeek?: number;
}

export default function AscSkillsActivityStatsCard({
  completedPercentage = 0,
  learningHours = 0,
  className,
  loading = false,
  differenceToPreviousWeek = 0,
}: AscLearningActivityCardProps) {
  let arrowIcon;

  if (differenceToPreviousWeek > 0) {
    arrowIcon = <ArrowUpIcon />;
  } else if (differenceToPreviousWeek < 0) {
    arrowIcon = <ArrowUpIcon className={styles.arrowDown} />;
  }
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
      loading={loading}
    >
      <div className={styles.textContent}>
        <div className={styles.averageContainer}>
          <div className={styles.average}>{learningHours}</div>
          <div className={styles.averageLabel}>learning hours</div>
        </div>
        <div className={styles.complete}>
          {arrowIcon}
          <span className={styles.text}>
            <b className={styles.bold}>{differenceToPreviousWeek}%</b> to
            previous week
          </span>
        </div>
      </div>
      <AscCircularProgressBar
        className={styles.progressBar}
        percentage={completedPercentage}
      />
    </AscGenericCard>
  );
}
